import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
class topScroll {
    constructor() {
        this.progress = 0;
        this.slideClasses = ["slide1", "slide2", "slide3", "slide4"];
        this.dataList = document.querySelector(".data__cnt");
        if (!this.dataList)
            return;
        this.init();
    }
    init() {
        ScrollTrigger.create({
            trigger: ".pinned-section",
            pin: true,
            scrub: 0.5,
            anticipatePin: 1,
            start: "top",
            end: "+=400%",
            fastScrollEnd: true,
            invalidateOnRefresh: true,
            //markers: true, // 開発時のデバッグ用マーカー
            onUpdate: (self) => {
                // 0から1の値を0から100に変換
                this.progress = Math.round(self.progress * 100);
                // 進捗状況をコンソールに表示
                console.log(`Progress: ${this.progress}%`);
                this.updateIndicator(this.progress);
            },
        });
    }
    updateIndicator(progress) {
        this.slideClasses.forEach((className) => {
            this.dataList.classList.remove(className);
        });
        // progressの値に応じて適切なクラスを追加
        if (progress <= 25) {
            this.dataList.classList.add("slide1");
        }
        else if (progress <= 50) {
            this.dataList.classList.add("slide2");
        }
        else if (progress <= 75) {
            this.dataList.classList.add("slide3");
        }
        else {
            this.dataList.classList.add("slide4");
        }
    }
}
new topScroll();
